import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import Button from "../../../../../../components/Button";
import Grid from "../../../../../../components/Grid";
import { GridStructure } from "../../../../../../components/Layout/Dashboard/styles";
import LineGraphHorizontal from "../../../../../../components/LineGraphHorizontal";
import Loader from "../../../../../../components/Loader";
import PieChart from "../../../../../../components/PieChart";
import {
  FlexContainer,
  PageTitle,
} from "../../../../../../components/StyledComponents";
import { DateEStoDateEN } from "../../../../../../helpers/format-date";
import { getAcademyStats } from "../../../../../../store/actions/analytics";
import AnalyticCard from "../../../components/AnalyticCard";
import NotData from "../../../components/NotData";
import { PDFExport } from "@progress/kendo-react-pdf";
import {
  formatNumber,
  overThousandFixed,
} from "../../../../../../helpers/number-fixed";
import { AcademyAnalyticsDto } from "../../../../../../types/analytics.dto";
import { CurrentDto } from "../../../../../../types/current.dto";
import { StateDto } from "../../../../../../types/states.dto";

const Component = ({
  analyticsAcademy,
  analyticsAcademyStates,
  current,
}: {
  analyticsAcademy: AcademyAnalyticsDto;
  analyticsAcademyStates: StateDto;
  current: CurrentDto;
}) => {
  const printRef: any = React.useRef();
  const dispatch = useDispatch();
  const handleExportWithComponent = () => {
    printRef.current.save();
  };
  useEffect(() => {
    dispatch(getAcademyStats({ _id: current.id }));
  }, []);
  if (!analyticsAcademy) return <Loader color="Primary"></Loader>;

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <Grid.Col offset={{ sm: 10 }} sm={12}>
        <Button
          onClick={() => {
            handleExportWithComponent();
          }}
          type="button"
          options={{
            type: "filled",
            skin: "primary",
            size: "md",
            marginBottom: "10px",
          }}
          style={{ marginLeft: "10px" }}
        >
          Descargar
        </Button>
      </Grid.Col>
      <PDFExport
        fileName={`Constana Laboral ${new Date().valueOf()}`}
        ref={printRef}
      >
        <FlexContainer direction="column" gap="6px">
          <AnalyticCard
            graphTitle="Talentos contactados - Crecimiento Histórico"
            title={"Talentos Contactados"}
            data={{
              stats: [
                {
                  label: "Últimos 30 días",
                  value: overThousandFixed(
                    analyticsAcademy.talents.contacts.lastMonth
                  ),
                },
                {
                  label: "Últimos 7 días",
                  value: overThousandFixed(
                    analyticsAcademy.talents.contacts.lastWeek
                  ),
                },
                {
                  label: "Últimas 24 horas",
                  value: overThousandFixed(
                    analyticsAcademy.talents.contacts.lastDay
                  ),
                },
              ],
              graphData: Object.entries(
                analyticsAcademy.talents.contacts.growth
              )
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
          <AnalyticCard
            title={"Talentos Marcados"}
            graphTitle="Talentos marcados - Crecimiento Histórico"
            data={{
              stats: [
                {
                  label: "Últimos 30 días",
                  value: overThousandFixed(
                    analyticsAcademy.talents.saves.lastMonth
                  ),
                },
                {
                  label: "Últimos 7 días",
                  value: overThousandFixed(
                    analyticsAcademy.talents.saves.lastWeek
                  ),
                },
                {
                  label: "Últimas 24 horas",
                  value: overThousandFixed(
                    analyticsAcademy.talents.saves.lastDay
                  ),
                },
              ],
              graphData: Object.entries(analyticsAcademy.talents.saves.growth)
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>

          <AnalyticCard height="250px" title="Top 10 Talentos Contactados">
            <NotData data={analyticsAcademy.talents.contacts.topTen}>
              <LineGraphHorizontal
                data={analyticsAcademy.talents.contacts.topTen.map(
                  (contact) => {
                    return {
                      label: contact.name,
                      value: formatNumber(contact.contactCount),
                    };
                  }
                )}
                title={"Alumnos"}
              ></LineGraphHorizontal>
            </NotData>
          </AnalyticCard>
          <AnalyticCard height="250px" title="Top 10 Talentos Marcados">
            <NotData data={analyticsAcademy.talents.saves.topTen}>
              <LineGraphHorizontal
                data={analyticsAcademy.talents.saves.topTen.map((contact) => {
                  return {
                    label: contact.name,
                    value: formatNumber(contact.saveCount),
                  };
                })}
                title={"Alumnos"}
              ></LineGraphHorizontal>
            </NotData>
          </AnalyticCard>
          <GridStructure
            style={{ width: "100%" }}
            type="auto-fit"
            width="400px"
          >
            <AnalyticCard
              height="300px"
              title="Genero de talentos marcados y contactados"
            >
              <NotData data={analyticsAcademy.talents.genders}>
                <PieChart
                  pieData={analyticsAcademy.talents.genders.map((contact) => {
                    return {
                      label: contact._id,
                      value: formatNumber(contact.count),
                    };
                  })}
                ></PieChart>
              </NotData>
            </AnalyticCard>
            <AnalyticCard
              height="300px"
              title="Edad de talentos marcados y contactados"
            >
              <NotData data={analyticsAcademy.talents.ages}>
                <PieChart
                  pieData={analyticsAcademy.talents.ages.map((age) => {
                    return {
                      label: age._id,
                      value: formatNumber(age.count),
                    };
                  })}
                ></PieChart>
              </NotData>
            </AnalyticCard>
          </GridStructure>
        </FlexContainer>
      </PDFExport>
    </>
  );
};

const states = ({ analyticsStore, currentStore }) => {
  const { data: analyticsAcademy, states: analyticsAcademyStates } =
    analyticsStore.getAcademyStats;
  const { data: current } = currentStore;
  return {
    analyticsAcademy,
    analyticsAcademyStates,
    current,
  };
};

export default connect(states)(Component);
